import React, { useEffect } from 'react';
import styled from 'styled-components';

import { Row } from 'bs';

const StyledRow = styled(Row)`
    position: fixed;
    top: ${props => props.theme.modalBackgroundTop};
    height: 100%;
    width: 100%;

    #row-modal-background {
        position: fixed;
        height: 100%;
        width: 100%;
        opacity: 0.5;
        background-color: black;
    }
    #row-modal-content {
        max-height: calc(100vh - ${props => props.theme.headerHeight});
        overflow-y: auto;
        overflow-x: hidden;
    }
`;

export const ModalBackground = ({ style, children }) => {
    useEffect(() => {
        document.body.classList.add('overflow-hidden');
        return () => document.body.classList.remove('overflow-hidden');
    }, []);

    return (
        <StyledRow id='row-modal' className='z-strato' style={style}>
            <div id='row-modal-background' />
            <div className='container-fluid' id='row-modal-content'>
                {children}
            </div>
        </StyledRow>
    );
};

export default ModalBackground;
